import { BaseModel } from '@/api/base-model'
import { RealworksStatusRuleAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { StatusReason } from '@/api/model/status-reason'

export class RealworksStatusRule extends BaseModel<RealworksStatusRule> {
    protected collectionName = RealworksStatusRuleAPI.collectionName

    constructor(
        public id: string,
        public company: Company,
        public kenmerken: string[],
        public agendaTypes: string[],
        public agendaStatus: string|null,
        public taakTypes: string[],
        public taakStatus: string|null,
        public referralTypes: string[],
        public statuses: string[],
        public statusReasons: string[],
        public pipeline: Pipeline|null,
        public phases: PipelinePhase[],
        public toStatus: string,
        public toStatusReason: string|null,
        public toNewStatusReason: StatusReason|null,
        public toPhase: PipelinePhase|null,
        public assignToMedewerker: boolean,
        public comment: string,
        public notifyAssignedTo: boolean,
        public active: boolean,
        public applyToTriggeredReferrals: boolean,
        public applyToTriggeredReferralsPastDays: number,
        public createdAt: Date|null,
        public updatedAt: Date|null,
    ) {
        super(id)
    }

    get triggerType(): string {
        if (this.kenmerken?.length > 0) {
            return 'kenmerken'
        } else if (this.agendaTypes?.length > 0) {
            return 'agendaTypes'
        } else if (this.taakTypes?.length > 0) {
            return 'taakTypes'
        } else {
            return 'kenmerken'
        }
    }

    static fromData(data: any) {
        if (data === null || typeof data === 'string' || data instanceof RealworksStatusRule) {
            return data
        }

        return new RealworksStatusRule(
            data.id,
            data.company,
            data.kenmerken ?? [],
            data.agendaTypes ?? [],
            data.agendaStatus,
            data.taakTypes ?? [],
            data.taakStatus,
            data.referralTypes ?? [],
            data.statuses ?? [],
            data.statusReasons ?? [],
            data.pipeline ? Pipeline.fromData(data.pipeline) : null,
            data.phases ? data.phases.map(phase => PipelinePhase.fromData(phase)) : [],
            data.toStatus,
            data.toStatusReason,
            data.toNewStatusReason ? StatusReason.fromData(data.toNewStatusReason) : null,
            data.toPhase ? PipelinePhase.fromData(data.toPhase) : null,
            data.assignToMedewerker,
            data.comment,
            data.notifyAssignedTo,
            data.active,
            data.applyToTriggeredReferrals,
            data.applyToTriggeredReferralsPastDays,
            data.createdAt,
            data.updatedAt,
        )
    }
}
